import React from 'react';

const Stack = () => {
    const skills = [
        { category: "Languages", items: ["C++", "Python", "JavaScript", "HTML/CSS", "Dart"] },
        { category: "Frameworks & Libraries", items: ["React.js", "Flutter", "Node.js", "Flask", "Tailwind CSS"] },
        { category: "Tools & Platforms", items: ["Docker", "Git", "GitHub", "SSH", "Firebase"] },
        { category: "Specialized", items: ["Robotics Systems", "Automated Analytics", "RESTful APIs"] }
    ];

    return (
        <main className="pt-32 pb-24 min-h-screen bg-background-dark">
            <div className="max-w-[1200px] mx-auto px-8">
                <div className="flex items-center gap-4 mb-16">
                    <span className="w-12 h-[2px] bg-primary"></span>
                    <h1 className="text-5xl md:text-7xl font-black sports-font text-white">
                        TECH <span className="text-primary">STACK</span>
                    </h1>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    {skills.map((skillGroup, index) => (
                        <div key={index} className="bg-surface-dark border border-white/5 p-10 hover:border-primary/50 transition-colors group">
                            <h3 className="text-xl font-black uppercase tracking-widest text-white mb-8 flex items-center gap-3">
                                <span className="w-2 h-2 bg-primary"></span>
                                {skillGroup.category}
                            </h3>
                            <div className="flex flex-wrap gap-3">
                                {skillGroup.items.map((skill, i) => (
                                    <span key={i} className="px-4 py-2 bg-white/5 text-white/80 border border-white/10 hover:bg-primary hover:text-black hover:border-primary transition-all font-mono text-sm cursor-default">
                                        {skill}
                                    </span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default Stack;
